import React from 'react';
import { AIOrderingDashboardWithProvider } from '../../basicOrganizationApplications/components/AIOrderingDashboard';
import { AppNameMap, EntityNameMap } from '../../../../../shared/utils/engagementAnalyticsTransformers';
import PlatformDashboardShell from './PlatformDashboardShell';
import { PlatformOrganizationItemModel } from './PlatformOrganizationItem';

interface PlatformOrderingDashboardContentProps {
    organizations: PlatformOrganizationItemModel[];
    appNameMap: AppNameMap;
    entityNameMap: EntityNameMap;
    representativeAppId?: string;
    platformAppIdsByOrganizationId: Record<string, string[]>;
    selectedAppLiveStatusMap?: Record<string, boolean>;
    isLoading: boolean;
}

const PlatformOrderingDashboardContent: React.FC<PlatformOrderingDashboardContentProps> = (props) => {
    return (
        <PlatformDashboardShell
            title="Platform Ordering"
            variant="ordering"
            organizations={props.organizations}
            appNameMap={props.appNameMap}
            selectedAppLiveStatusMap={props.selectedAppLiveStatusMap}
            entityNameMap={props.entityNameMap}
            representativeAppId={props.representativeAppId}
            platformAppIdsByOrganizationId={props.platformAppIdsByOrganizationId}
            isLoading={props.isLoading}
            DashboardComponent={AIOrderingDashboardWithProvider}
        />
    );
};

export default PlatformOrderingDashboardContent;
